import {
  Request
} from '../index'

/** 出差申请单初始化接口 */
export function kpiApplicationInit(data = {}) {
  return Request('tripformapi/Application/Init', 'post', undefined, data)
}
/** 出差申请单获取审批人列表 */
export function kpiAppointApproverList(data = {}) {
  return Request('tripformapi/Application/AppointApproverList', 'post', undefined, data)
}
/** 获取城市列表接口 */
export function kpiApplicationCityList(data = {}) {
  return Request('tripformapi/Application/CityList', 'post', undefined, data)
}
/** 国际城市列表接口 */
export function kpiApplicationIntlCityList(data = {}) {
  return Request('tripformapi/Application/IntlCityList', 'post', undefined, data)
}
/** 城市搜索接口 */
export function kpiApplicationSearchCity(data = {}) {
  return Request('tripformapi/Application/SearchCity', 'post', undefined, data)
}
/** 根据城市获取出差需求类型 */
export function kpiApplicationGetBusinessType(data = {}) {
  return Request('tripformapi/Application/GetBusinessType', 'post', undefined, data)
}
/** 出差申请单校验接口 */
export function kpiApplicationValidate(data = {}) {
  return Request('tripformapi/Application/Validate', 'post', undefined, data)
}
/** 获取审批流接口 */
export function kpiApplicationGetApprovalFlow(data = {}) {
  return Request('tripformapi/Application/GetApprovalFlow', 'post', undefined, data)
}
/** 先定后审保存出差申请单 */
export function kpiApplicationSavePreOrder(data = {}) {
  return Request('tripformapi/Application/SavePreOrder', 'post', undefined, data)
}
/** 先定后审提交出差申请单 */
export function kpiApplicationSubmitPreOrder(data = {}) {
  return Request('tripformapi/Application/SubmitPreOrder', 'post', undefined, data)
}
/** 获取审批流 */
export function kpiApplicationGetApprovalFlowV2(data = {}) {
  return Request('tripformapi/Application/GetApprovalFlowV2', 'post', undefined, data)
}
/** 先审后定提交出差申请单 */
export function kpiApplicationSaveAndSubmitAfterOrder(data = {}) {
  return Request('tripformapi/Application/SaveAndSubmitAfterOrderV2', 'post', undefined, data)
}
/** 出差申请单详情接口 */
export function kpiApplicationDetail(data = {}) {
  return Request('tripformapi/Application/Detail', 'post', undefined, data)
}

/** 出差申请单列表 */
export function kpiApplicationList(data = {}) {
  return Request('tripformapi/Application/List', 'post', undefined, data)
}

/** 取消出差申请单 */
export function kpiCancelApplicationOrder(data = {}) {
  return Request('tripformapi/Application/CancelApplicationOrder', 'post', undefined, data)
}
